import IntakeDocketsList from './List';
import IntakeDocketsEdit from './Form';

export default {
  list: IntakeDocketsList,
  edit: IntakeDocketsEdit,
};
